import {
  NativeNamespaces,
  QrCodeNativeMethods,
} from '@mobile-data-access-enums';
import { RpcRequest } from '@message-bus/core';

@RpcRequest(NativeNamespaces.QR_CODE, QrCodeNativeMethods.READ)
export class ReadQrCodeNativeMethod {}
